export const DefaultReiHeatmapSchema = {
	Rent: {
		rentType: [],
		developer: [],
		propertySubType: [],
		year: [],
		noOfBedrooms: [],
		volume: '',
		avg_price: '',
		avg_price_per_sqm: '',
	},
	Sales: {
		salesType: [],
		developer: [],
		propertySubType: [],
		year: [],
		noOfBedrooms: [],
		volume: '',
		avg_price: '',
		avg_price_per_sqm: '',
	},
};
